import loadable from '@loadable/component'
import {RouteConfig} from 'react-router-config'

export default [
  {
    path: '/blind-box/challenge',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-blind-box-challenge" */ '~/pages/blindBox/challenge'
        )
    ),
  },
  {
    path: '/blind-box/detail',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-blind-box-detail" */ '~/pages/blindBox/detail'
        )
    ),
  },
  {
    path: '/blind-box/modal',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-blind-box-modal" */ '~/pages/blindBox/GiftModal/index'
        )
    ),
  },
] as RouteConfig[]
